var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseSmall28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.8536 6.85355C22.0488 6.65829 22.0488 6.34171 21.8536 6.14645C21.6583 5.95118 21.3417 5.95118 21.1464 6.14645L14.5 12.7929L7.85355 6.14645C7.65829 5.95118 7.34171 5.95118 7.14645 6.14645C6.95118 6.34171 6.95118 6.65829 7.14645 6.85355L13.7929 13.5L7.14645 20.1464C6.95118 20.3417 6.95118 20.6583 7.14645 20.8536C7.34171 21.0488 7.65829 21.0488 7.85355 20.8536L14.5 14.2071L21.1464 20.8536C21.3417 21.0488 21.6583 21.0488 21.8536 20.8536C22.0488 20.6583 22.0488 20.3417 21.8536 20.1464L15.2071 13.5L21.8536 6.85355Z",
  fill: "currentColor"
})));
export { SvgCloseSmall28 as ReactComponent };
export default __webpack_public_path__ + "f2c982bd1429d894a2695971117f7d6c.svg";